import Loadable from '../../utils/Loadable';

export default Loadable(() => import('./ExpeditionIndex'));
